import { TFunction } from 'i18next';
import { SelectOption } from 'components/Forms';

export enum RescheduleReason {
  outage = 'outage',
  school = 'school',
  work = 'work',
  vacation = 'vacation',
  sick = 'sick',
  other = 'other',
}

export const getRescheduleReasonOptions = (t: TFunction): SelectOption[] => {
  return Object.keys(RescheduleReason).map(reasonCode => ({
    value: reasonCode,
    label: t(`appointment.reschedule.reasons.${reasonCode}`),
  }));
};
